import { createSlice } from "@reduxjs/toolkit";

import { ReduxReducer } from "../../../../interface";
import { Accounting } from "../../interface";

import { State } from "./interface";

const initialState: State = {
	items: [],
	counters: { count: 0, amount: 0 },
	loaded: false,
};

const setItems: ReduxReducer<State, State["items"]> = (state, { payload }) => {
	state.items = payload;
	state.loaded = true;
};

const setCounters: ReduxReducer<State, State["counters"]> = (
	state,
	{ payload },
) => {
	state.counters = payload;
};

const reset: ReduxReducer<State, any> = (state) => {
	Object.keys(initialState).forEach((key) => {
		state[key] = initialState[key];
	});
};

const data = createSlice({
	name: Accounting.ConstantAccountingSlice.REPLENISHMENTS,
	initialState,
	reducers: {
		reset,
		setItems,
		setCounters,
	},
});

export const dataAction = data.actions;
export const dataReducer = data.reducer;
export type dataState = State;

export default data;
